import { WorkspaceSelector } from '../workspace-selector/workspace-selector';
import { PageHeaderProps } from './types';

export const PageHeader = ({ title, icon }: PageHeaderProps): JSX.Element => {
  return (
    <header className="flex items-center justify-between border-b border-[#00000020] bg-prompt-safecomfantasy px-5">
      <div className="flex h-16 w-full items-center justify-between gap-2 px-1">
        <div className="flex items-center gap-2">
          {icon}
          <h1 className="font-prompt-safe-com-semantic-heading-1 text-prompt-safecomvulcan">
            {title}
          </h1>
        </div>
        <div className="flex flex-col">
          <div className="w-[350px]">
            <WorkspaceSelector />
          </div>
        </div>
      </div>
    </header>
  );
};
